<template>
    <div>
        <buttonlist @help="help" @exps="exps" ref="SetBtn"></buttonlist>
        <table>
            <tr>
                <td style="width:60px">{{$t('getapi[6373]')}}</td>
                <td style="width:160px">
                    <el-date-picker
                            v-model="timestart"
                            value-format="yyyy-MM"
                            type="month">
                    </el-date-picker>
                </td>
                <td style="width:60px">{{$t('getapi[6374]')}}</td>
                <td style="width:160px">
                    <el-date-picker
                            v-model="timeend"
                            value-format="yyyy-MM"
                            type="month">
                    </el-date-picker>
                </td>
            </tr>
            <tr>
                <td>{{$t('getapi[1507]')}}</td>
                <td>
                    <routejump :urlNo="26">
                    <el-input
                            v-model="vender_code"
                            type="text"
                            readonly
                            size="mini"
                            class="mcolor"
                    >
                        <i class="el-icon-edit el-input__icon" slot="suffix"
                           @click="selectVender(scope)"></i>
                    </el-input>
                    </routejump>
                </td>
                <td>{{$t('getapi[1197]')}}</td>
                <td>
                    <el-input v-model="vender_name"></el-input>
                </td>
                <td>
                    <el-button type="primary" size="mini" style="margin-left: 5px;" @click="getView()">{{$t('getapi[1980]')}}
                    </el-button>
                </td>
            </tr>
        </table>
                <vxe-table
                        :data="dataSet"
                        v-loading="loading"
                        border
                        stripe
                        resizable
                        size="mini"
                        :height="tableHeight"
                        :auto-resize="true"
                        ref="singleTable"
                >

                    <vxe-table-column show-overflow field="vender_code" :title="$t('getapi[1287]')" width='150'/>
                    <vxe-table-column show-overflow field="sort_name" :title="$t('getapi[1096]')" width='150'/>
                    <vxe-table-column show-overflow field="item_code" :title="$t('getapi[1288]')" width='100'/>
                    <vxe-table-column show-overflow field="part_code" :title="$t('getapi[112]')" width='100'/>
                    <vxe-table-column show-overflow field="part_version" :title="$t('getapi[149]')" width='100'/>
                    <vxe-table-column field="ppv" :title="$t('getapi[6375]')" align="right"
                                      width='100'>
                        <template slot-scope="scope">
                            {{scope.row.ppv | thousandth}}
                        </template>
                    </vxe-table-column>

                </vxe-table>

        <selector :isVisible="false" :isBatch=false :isSplitPage=true
                  :postUrl="'/Sch/Quotation/GetDerQJVenderCodePopupList'" @callback="getVender" ref="vender"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: 'quojiang',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight2 - 20
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                timestart: '',
                timeend: '',
                vender_code: '',
                vender_name: '',
                loading: false,
                scrollTop:0,
            };
        },
        mounted: function () {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            that.timestart = Common.methods.getDate()
            that.timeend = Common.methods.getDate()
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })

        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[95]"),this.$t("getapi[17]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                let limits = 1;
                that.$refs.SetBtn.SetButtonEnable('export', true);
                return;
            },
            getView() {
                let that = this;
                let datac = {
                    "vender_code": that.vender_code,
                    "timestart": that.timestart,
                    "timeend": that.timeend
                };
                that.loading = true;
                //console.log(datac)
                that.$http.urlpost('/Sch/Quotation/GetVenDerQuoJiangView', datac, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                    }
                    that.loading = false;
                });
            },
            // 导出
            exps() {
                let that = this;
                that.loading = true;
                let datac = {
                    "vender_code": that.vender_code,
                    "timestart": that.timestart,
                    "timeend": that.timeend,
                    LangType: that.$processdata.getLang(),
                    fromname: that.$t('getapi[95]')
                };
                that.$http.urlpost('/Sch/Quotation/GetVenDerQuoJiangViewToExecl', datac, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });
            },
            selectVender() {
                let that = this;
                that.$refs.vender.clearInput(true);
            },
            getVender(val) {
                let that = this;
                console.log(val)
                that.vender_code = val.vender_code;
                that.vender_name = val.vender_name;
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    .bbl {
        margin: 0px auto 10px;
        white-space: pre;
        span {
            margin-left: 10px;
            min-width: 70px;
            text-align: left;
            line-height: 20px;
            display: inline-block;
            margin-right: 0px;
        }
    }
</style>
